import LottieView from "lottie-react-native";
import { Box } from "native-base";
import React, { useEffect, useRef } from "react";
import { Platform } from "react-native";

interface LottieAnimationProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  source: any;
  width?: number | string | number[] | string[];
  height?: number | string | number[] | string[];
  autoPlay?: boolean;
  loop?: boolean;
  speed?: number;
  testID?: string;
}

const LottieAnimation: React.FC<LottieAnimationProps> = ({
  source,
  width = 200,
  height = 200,
  autoPlay = true,
  loop = true,
  speed = 1,
  testID,
}) => {
  const animationRef = useRef<LottieView>(null);

  useEffect(() => {
    if (Platform.OS === "web" && animationRef.current && autoPlay) {
      // Web platform may need explicit play call
      animationRef.current.play();
    }
  }, [autoPlay]);

  // Handle responsive sizing
  const getSize = (size: number | string | number[] | string[]): number => {
    if (Array.isArray(size)) {
      return typeof size[0] === "string" ? parseInt(size[0], 10) : size[0] || 200;
    }
    return typeof size === "string" ? parseInt(size, 10) : size || 200;
  };

  return (
    <Box width={width} height={height} alignItems="center" justifyContent="center">
      <LottieView
        ref={animationRef}
        source={source}
        style={{
          width: getSize(width),
          height: getSize(height),
        }}
        autoPlay={autoPlay}
        loop={loop}
        speed={speed}
        testID={testID}
      />
    </Box>
  );
};

export default LottieAnimation;
